export default __webpack_public_path__ + "static/media/rep_8.18dabad4.mp3";